import { siteInfo, footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-500 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="md:col-span-1">
            <span className="text-xl font-heading font-bold text-background-50 mb-4 block">{siteInfo.name}</span>
            <p className="text-xs md:text-sm text-background-50/80 leading-relaxed">
              {footerData.intro}
            </p>
          </div>

          {footerData.links.map((col, idx) => (
            <div key={idx}>
              <h3 className="text-sm font-bold text-background-50 mb-4">{col.title}</h3>
              <ul className="space-y-2">
                {col.items.map((item, i) => (
                  <li key={i}>
                    <a
                      href={item === '首页' ? '#hero' : item === '最新更新' ? '#updates' : item === '热门排行' ? '#ranking' : item === '常见问题' ? '#faq' : item === '分类浏览' ? '#index' : item === '联系我们' ? '#contact' : item === '平台介绍' ? '#about' : '#hero'}
                      onClick={(e) => {
                        const href = item === '首页' ? '#hero' : item === '最新更新' ? '#updates' : item === '热门排行' ? '#ranking' : item === '常见问题' ? '#faq' : item === '分类浏览' ? '#index' : item === '联系我们' ? '#contact' : item === '平台介绍' ? '#about' : '#hero';
                        handleNavClick(e, href);
                      }}
                      className="text-xs md:text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/20 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xs text-background-50/60">
              &copy; {new Date().getFullYear()} {siteInfo.name} · 韩漫日漫国漫免费全集在线阅读平台
            </div>
            <div className="text-xs text-background-50/50">
              合作伙伴区域 · 敬请期待
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}